export const filterHeaders = {
    // Lists section
    assigned_users: "User",
    assigned_teams: "Team",
    list_status: "Status",

    // Voter/Contact section
    gender: "Gender",
    party: "Party",
    volunteer: "Volunteer",
    deceased: "Deceased",
    employment_status: "Employment",
    donor: "Donor",
    email: "Email",
    homephone: "Home Phone",
    mobilephone: "Mobile Phone",
    credit_rating: "Credit Rating",
    donor_environmental: "Interested in Green Living",
    income: "Income",
    age: "Age",
    contact_details: "Contact Details",
    contact_method: "Contact Methods",
    imports: "Imports",
    app_type: "Voter Origin",
    group: "List",
    consenttype: "Consent type",
    division: "Division",
    campaign: "Sub-Account",

    // House section
    location_type: "Location Type",
    precinct: "Precinct",
    street: "Street",
    zipcode: "Zip Code",
    notes: "Notes",
    building: "In Building",
    dwelling_type: "Dwelling Type",
    homeowner: "Home Owner",
    square_footage: "Square Footage",
    purchase_price: "Purchase Price",
    purchase_year: "Purchase Year",
    year_built: "Year Built",
    net_worth: "Household Net Worth",
    access_type: "Access Type",
    building_notes: "Building Notes",

    // Effort-specific filters (these would be dynamic per effort)
    canvass_type: "Interaction Status",
    reception: "Rating",
    canvasser: "Interaction Performed By",
    queried: "Logged follow-up request",
    surveyed: "Surveyed",
    signature: "Gave Signature",
    last_interacted: "Last Interacted With",

    // Search
    search: "Search",

    // Section headers (for reference)
    lists: "Lists",
    voter: "Voter", // or use $ctrl.__env.strings.voter
    house: "House",
    surveys: "Surveys",
    elections: "Elections",
    custom_fields: "Custom Fields",
} as const;
